"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cervia": {
    "a50a7899": [{
      "hkey": "5633b25a",
      "slug": "montaletto-visdomina",
      "name": "Montaletto-Visdomina",
      "primary": true,
      "skipSearch": false
    }],
    "montaletto": [{
      "hkey": "5633b25a",
      "slug": "montaletto-visdomina",
      "name": "Montaletto-Visdomina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fd887d50": [{
      "hkey": "b81f190b",
      "slug": "tantlon",
      "name": "Tantlon",
      "primary": true,
      "skipSearch": false
    }],
    "saline": [{
      "hkey": "b81f190b",
      "slug": "tantlon",
      "name": "Tantlon",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;